import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, useToast } from '@chakra-ui/react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { stripeKey } from 'utils/constants';
import AddPaymentSource from './AddPaymentSource';


import useServerApi from '../../../hooks/useServerApi';

const AddPaymentModal = ({ isOpen, onClose, onSuccess, setErrors }) => {
    const [{ post }] = useServerApi();
    const stripePromise = loadStripe(stripeKey);
    const [localError, setLocalError] = React.useState('');
    const toast = useToast();

    const handleAddPaymentSource = async ({ paymentMethodId }) => {
        try {
            const result = await post('/rest_endpoints/stripe/crud/add_payment_source', { payment_id: paymentMethodId });
            const [success, , data] = result;

            if (success) {
                setLocalError('');
                setErrors && setErrors('');
                toast({
                    title: 'Payment source added',
                    description: 'Your payment method was added successfully.',
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                });
                if (onSuccess) await onSuccess();
                onClose();
                return true;
            } else {
                const errorMsg = data?.detail || 'Failed to add payment source';
                setLocalError(errorMsg);
                setErrors && setErrors(errorMsg);
                return false;
            }
        } catch (error) {
            setLocalError('An unexpected error occurred while adding the payment source');
            setErrors && setErrors('An unexpected error occurred while adding the payment source');
            return false;
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent maxW="md">
                <ModalHeader>Add Payment Source</ModalHeader>
                <ModalBody>
                    {localError && (
                        <div style={{ color: 'red', marginBottom: '12px', fontSize: '0.95em' }}>{localError}</div>
                    )}
                    <Elements stripe={stripePromise}>
                        <AddPaymentSource
                            onAdd={async (paymentMethodId, errors) => {
                                if (paymentMethodId && paymentMethodId !== '') {
                                    return handleAddPaymentSource({ paymentMethodId });
                                }
                                const errorMsg = errors.join(', ');
                                setLocalError(errorMsg);
                                setErrors && setErrors(errorMsg);
                                return false;
                            }}
                            onCancel={onClose}
                        />
                    </Elements>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default AddPaymentModal;
